// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioButtons_radio-buttons-list__ugJJi ul {
  list-style-type: none;
  margin: 0;
  padding: 5px;
}
.RadioButtons_radio-buttons-list__ugJJi ul li {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.RadioButtons_radio-buttons-list__ugJJi ul li * {
  transition: all 0.3s ease;
}
.RadioButtons_radio-buttons-list__ugJJi ul li .RadioButtons_radio-button__FbXRB {
  margin: 7px 10px 7px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 2px solid grey;
  border-radius: 8px;
}
.RadioButtons_radio-buttons-list__ugJJi ul li .RadioButtons_radio-button__FbXRB span {
  display: none;
  width: 8px;
  height: 8px;
  background-color: var(--accent-color);
  border-radius: 20px;
}
.RadioButtons_radio-buttons-list__ugJJi ul li .RadioButtons_radio-button__FbXRB.RadioButtons_selected__3nEPv {
  border-color: var(--accent-color);
}
.RadioButtons_radio-buttons-list__ugJJi ul li .RadioButtons_radio-button__FbXRB.RadioButtons_selected__3nEPv span {
  display: flex;
  animation: RadioButtons_click__Dsady 0.2s ease;
}
@keyframes RadioButtons_click__Dsady {
  0% {
    width: 0;
    height: 0;
    border-radius: 20px;
    box-shadow: 0 0 0 0 var(--accent-color-01-opacity);
  }
  100% {
    width: 8px;
    height: 8px;
    border-radius: 20px;
    box-shadow: 0 0 0 10px var(--accent-color-02-opacity);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/RadioButtons/RadioButtons.module.scss"],"names":[],"mappings":"AACG;EACG,qBAAA;EACA,SAAA;EACA,YAAA;AAAN;AAEM;EACG,aAAA;EACA,mBAAA;EACA,mBAAA;AAAT;AAES;EACG,yBAAA;AAAZ;AAGS;EACG,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AADZ;AAGY;EACG,aAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;EACA,mBAAA;AADf;AAIY;EACG,iCAAA;AAFf;AAIe;EACG,aAAA;EACA,8CAAA;AAFlB;AAKe;EACG;IACG,QAAA;IACA,SAAA;IACA,mBAAA;IACA,kDAAA;EAHnB;EAMgB;IACG,UAAA;IACA,WAAA;IACA,mBAAA;IACA,qDAAA;EAJnB;AACF","sourcesContent":[".radio-buttons-list {\n   ul {\n      list-style-type: none;\n      margin: 0;\n      padding: 5px;\n\n      li {\n         display: flex;\n         flex-direction: row;\n         align-items: center;\n\n         * {\n            transition: all 0.3s ease;\n         }\n\n         .radio-button {\n            margin: 7px 10px 7px 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 16px;\n            height: 16px;\n            border: 2px solid grey;\n            border-radius: 8px;\n\n            span {\n               display: none;\n               width: 8px;\n               height: 8px;\n               background-color: var(--accent-color);\n               border-radius: 20px;\n            }\n\n            &.selected {\n               border-color: var(--accent-color);\n\n               span {\n                  display: flex;\n                  animation: click 0.2s ease;\n               }\n\n               @keyframes click {\n                  0% {\n                     width: 0;\n                     height: 0;\n                     border-radius: 20px;\n                     box-shadow: 0 0 0 0 var(--accent-color-01-opacity);\n                  }\n\n                  100% {\n                     width: 8px;\n                     height: 8px;\n                     border-radius: 20px;\n                     box-shadow: 0 0 0 10px var(--accent-color-02-opacity);\n                  }\n               }\n            }\n         }\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio-buttons-list": `RadioButtons_radio-buttons-list__ugJJi`,
	"radio-button": `RadioButtons_radio-button__FbXRB`,
	"selected": `RadioButtons_selected__3nEPv`,
	"click": `RadioButtons_click__Dsady`
};
export default ___CSS_LOADER_EXPORT___;
